import { API_ROUTES } from '@/const/apiRoutes'
import api from '@/utils/api'
import type { ProfileStatus, ProfileCompletionData, SocialAuthProvider } from '@/types/auth'

const getRedirectUri = (): string => {
  return `${window.location.origin}/auth/callback`
}

export const socialAuthService = {
  /**
   * Initiate Google OAuth login by redirecting to the provider
   */
  initiateGoogleLogin(): void {
    const redirectUri = getRedirectUri()
    window.location.href = `${API_ROUTES.SOCIAL_AUTH_GOOGLE_LOGIN}?redirect_uri=${encodeURIComponent(redirectUri)}`
  },

  /**
   * Initiate LinkedIn OAuth login by redirecting to the provider
   */
  initiateLinkedInLogin(): void {
    const redirectUri = getRedirectUri()
    window.location.href = `${API_ROUTES.SOCIAL_AUTH_LINKEDIN_LOGIN}?redirect_uri=${encodeURIComponent(redirectUri)}`
  },

  /**
   * Initiate social login by provider name
   */
  initiateLogin(provider: SocialAuthProvider): void {
    switch (provider) {
      case 'google':
        this.initiateGoogleLogin()
        break
      case 'linkedin':
        this.initiateLinkedInLogin()
        break
      default:
        throw new Error(`Unknown social auth provider: ${provider}`)
    }
  },

  /**
   * Get profile completion status for the current user
   */
  async getProfileStatus(): Promise<ProfileStatus> {
    try {
      const response = await api.get(API_ROUTES.SOCIAL_AUTH_PROFILE_STATUS)
      console.log('[SocialAuth] Profile status response:', response.data)
      return response.data
    } catch (error) {
      console.error('[SocialAuth] Failed to get profile status:', error)
      throw error
    }
  },

  /**
   * Complete user profile with required fields
   */
  async completeProfile(data: ProfileCompletionData): Promise<void> {
    const response = await api.post(API_ROUTES.SOCIAL_AUTH_COMPLETE_PROFILE, data)
    
    if (response.status >= 400) {
      const error = response.data
      throw new Error(error.detail || 'Failed to complete profile')
    }
  }
}

export default socialAuthService
